<template>
    <div>
        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>

        <div v-else>
            <vue-headful :title="(jsa_id ? 'Edit' : 'Create') + ' JSA Template :: MeritEHS'"/>

            <h4 class="py-3 mb-4">
                <ol class="breadcrumb font-weight-bold m-0">
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/jsa/templates`">
                            <i class="fa fa-files-o"></i> JSA Templates
                        </router-link>
                    </li>
                    <template v-if="jsa.jsa_id">
                        <li class="breadcrumb-item font-weight-light">
                            <router-link :to="`/jsa/templates/view/${jsa.jsa_id}`">
                                {{ jsa.jsa_name }}
                            </router-link>
                        </li>
                        <li class="breadcrumb-item active">
                            <i class="fa fa-edit"></i> Edit
                        </li>
                    </template>
                    <template v-else>
                        <li class="breadcrumb-item active">
                            <i class="fa fa-plus-circle"></i> New
                        </li>
                    </template>
                </ol>
            </h4>

            <div class="mb-4">
                <button type="button" class="btn btn-sm btn-info btn-save" v-on:click="saveJsa();" :disabled="saving"><i class="fa fa-save"></i> Save</button>
            </div>

            <div class="row">
                <div class="col-xl-9 col-lg-10 col-md-12 mb-4">
                    <div class="card">
                        <div class="card-header">
                            General Information
                        </div>
                        <div class="card-body">
                            <div class="form-group row">
                                <label :class="{'col-lg-3 col-md-4 col-sm-5 col-form-label text-sm-right': true, 'text-danger': errors.jsa_name}">JSA Template Name: <i class="fa fa-asterisk small text-danger"></i></label>
                                <div class="col-sm-8">

                                   <b-form-input type="text" v-model="jsa.jsa_name" :class="{'is-invalid': errors.jsa_name}" placeholder="JSA Template Name"></b-form-input>

                                    <span v-if="errors.jsa_name" class="text-danger">
                                        <span v-for="error in errors.jsa_name">{{ error }}</span>
                                    </span>
                                </div>
                            </div>

                            <div v-bind:class="{ 'form-group': true, 'has-error': errors.jsa_contractor }" class="row">
                                <label class="col-lg-3 col-md-4 col-sm-5 col-form-label text-sm-right">Contractor:</label>
                                <div class="col-sm-8">
                                    <input type="text" name="jsa_contractor" v-model="jsa.jsa_contractor" class="form-control" placeholder="Enter Contractor" />
                                    <span v-if="errors.jsa_contractor" class="text-danger">
                                        <span v-for="error in errors.jsa_contractor">{{ error }}</span>
                                    </span>
                                </div>
                            </div>

                            <div class="form-group row">
                                <label class="col-lg-3 col-md-4 col-sm-5 col-form-label text-sm-right">Active:</label>
                                <div class="col-sm-8">
                                    <b-form-checkbox v-model="jsa.is_active" :value="1" :unchecked-value="0" plain />
                                </div>
                            </div>

                            <div class="form-group row">
                                <label class="col-lg-3 col-md-4 col-sm-5 col-form-label text-sm-right">Total # Of Steps:</label>
                                <div class="col-sm-8">
                                    {{ steps.length }}
                                </div>
                            </div>

                            <div class="form-group row">
                                <label class="col-lg-3 col-md-4 col-sm-5 col-form-label text-sm-right">Total # Of Hazards:</label>
                                <div class="col-sm-8">
                                    {{ totalHazards }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-9 col-lg-10 col-md-12 mb-4">
                    <b-card>
                        <template slot="header">Safety Description</template>

                        <div class="form-group row">
                            <label :class="{'col-lg-3 col-md-4 col-sm-5 col-form-label text-sm-right': true, 'text-danger': errors.jsa_building_area}">Building/Area:</label>
                            <div class="col-sm-8">

                                <b-form-textarea v-model="jsa.jsa_building_area" :class="{'is-invalid': errors.jsa_building_area}" rows="4" placeholder="Enter Building/Area"></b-form-textarea>

                                <span v-if="errors.jsa_building_area" class="text-danger">
                                    <span v-for="error in errors.jsa_building_area">{{ error }}</span>
                                </span>
                            </div>
                        </div>

                        <div class="form-group row">
                            <label :class="{'col-lg-3 col-md-4 col-sm-5 col-form-label text-sm-right': true, 'text-danger': errors.jsa_description}">Description of Work:</label>
                            <div class="col-sm-8">

                                <b-form-textarea v-model="jsa.jsa_description" :class="{'is-invalid': errors.jsa_description}" rows="4" placeholder="Enter Description of Work"></b-form-textarea>

                                <span v-if="errors.jsa_description" class="text-danger">
                                    <span v-for="error in errors.jsa_description">{{ error }}</span>
                                </span>
                            </div>
                        </div>

                        <div class="form-group row">
                            <label :class="{'col-lg-3 col-md-4 col-sm-5 col-form-label text-sm-right': true, 'text-danger': errors.jsa_safety_equipment}">Standard PPE:</label>
                            <div class="col-sm-8">

                                <b-form-textarea v-model="jsa.jsa_safety_equipment" :class="{'is-invalid': errors.jsa_safety_equipment}" rows="4" placeholder="Enter Standard PPE"></b-form-textarea>

                                <span v-if="errors.jsa_safety_equipment" class="text-danger">
                                    <span v-for="error in errors.jsa_safety_equipment">{{ error }}</span>
                                </span>
                            </div>
                        </div>

                        <div class="form-group row">
                            <label :class="{'col-lg-3 col-md-4 col-sm-5 col-form-label text-sm-right': true, 'text-danger': errors.jsa_specialized_equipment}">Specialized PPE:</label>
                            <div class="col-sm-8">

                                <b-form-textarea v-model="jsa.jsa_specialized_equipment" :class="{'is-invalid': errors.jsa_specialized_equipment}" rows="4" placeholder="Enter Specialized PPE"></b-form-textarea>

                                <span v-if="errors.jsa_specialized_equipment" class="text-danger">
                                    <span v-for="error in errors.jsa_specialized_equipment">{{ error }}</span>
                                </span>
                            </div>
                        </div>

                        <div class="form-group row">
                            <label :class="{'col-lg-3 col-md-4 col-sm-5 col-form-label text-sm-right': true, 'text-danger': errors.jsa_monitoring_act}">Monitoring Activities:</label>
                            <div class="col-sm-8">

                                <b-form-textarea v-model="jsa.jsa_monitoring_act" :class="{'is-invalid': errors.jsa_monitoring_act}" rows="4" placeholder="Enter Monitoring Activities"></b-form-textarea>

                                <span v-if="errors.jsa_monitoring_act" class="text-danger">
                                    <span v-for="error in errors.jsa_monitoring_act">{{ error }}</span>
                                </span>
                            </div>
                        </div>
                    </b-card>
                </div>
            </div>

            <button type="button" class="btn btn-sm btn-info btn-save" v-on:click="saveJsa();" :disabled="saving"><i class="fa fa-save"></i> Save</button>
            <hr/>

            <h5 class="mt-4 mb-2">
                Job Steps ({{ steps.length }})
                <b-button variant="success" size="sm" title="Add a New JSA Step" v-on:click="newStep()"><i class="fa fa-plus-circle"></i> Step</b-button>
            </h5>

            <div class="row">
                <div class="col-xl-9 col-lg-10 col-md-12">

                    <div v-if="errors.jsa_steps" class="alert alert-danger">
                        Some steps failed validation.
                        <ul>
                            <li v-for="errors in errors.jsa_steps">{{ errors }}</li>
                        </ul>
                    </div>

                    <div class="card mb-3" v-for="(step, index) in steps" :key="index">
                        <div class="card-header">
                            <div class="form-inline">

                                <div class="form-group mr-2">
                                    <b-button variant="danger" size="sm" v-on:click="deleteStep(index)" title="Delete Step"><i class="fa fa-trash"></i> Step</b-button>
                                </div>
                                <div class="form-group mr-2">
                                    <b-button variant="secondary" size="sm" v-on:click="newStepHazard(index)" title="Add a Hazard to a Step"><i class="fa fa-plus-circle"></i> Hazard</b-button>
                                </div>

                                <div class="form-group mr-2">
                                    <label class="ml-1 mr-1" :class="{'text-danger': errors['jsa_steps.'+index+'.step_label']}">Step Name:</label>
                                    <b-form-input :class="{'is-invalid': errors['jsa_steps.'+index+'.step_label']}" v-model="step.step_label" style="width: 300px;" size="sm" placeholder="Enter Step Name"></b-form-input>
                                </div>

                                <div class="form-group mr-2">
                                    # of Hazards: ({{ step.hazards.length }})
                                </div>

                                <span v-if="errors['jsa_steps.'+index+'.step_label']" class="text-danger">
                                    &nbsp;<span v-for="error in errors['jsa_steps.'+index+'.step_label']">{{ error }}</span>
                                </span>
                            </div>
                        </div>

                        <div class="card-body">
                            <template v-for="(haz, hIndex) in step.hazards">
                                <hr v-if="hIndex > 0" />
                                <div class="border border-light bg-light py-3 px-4">
                                    <div class="form-inline mb-2">
                                        <div class="form-group mr-3">
                                            <b-button variant="danger" size="xs" v-on:click="deleteStepHazard(index, hIndex)" title="Delete Hazard"><i class="fa fa-trash"></i></b-button>
                                        </div>
                                        <div class="form-group mr-3">
                                            <label :class="{'text-danger': errors['jsa_steps.'+index+'.hazards.'+hIndex+'.hazard']}" class="mr-1">Hazard:</label>
                                            <b-form-select :class="{'is-invalid': errors['jsa_steps.'+index+'.hazards.'+hIndex+'.hazard']}" :options="selectHazards" v-model="haz.hazard" size="sm"></b-form-select>
                                            <span v-if="errors['jsa_steps.'+index+'.hazards.'+hIndex+'.hazard']" class="text-danger">
                                                &nbsp;<span v-for="error in errors['jsa_steps.'+index+'.hazards.'+hIndex+'.hazard']">{{ error }}</span>
                                            </span>
                                        </div>
                                        <div class="form-group">
                                            <label :class="{'text-danger': errors['jsa_steps.'+index+'.hazards.'+hIndex+'.rac_level']}" class="mr-1">RAC Level:</label>
                                            <b-form-select :class="{'is-invalid': errors['jsa_steps.'+index+'.hazards.'+hIndex+'.rac_level']}" :options="selectRacLevels" v-model="haz.rac_level" size="sm"></b-form-select>
                                            <span v-if="errors['jsa_steps.'+index+'.hazards.'+hIndex+'.rac_level']" class="text-danger">
                                                <span v-for="error in errors['jsa_steps.'+index+'.hazards.'+hIndex+'.rac_level']">{{ error }}</span>
                                            </span>
                                        </div>
                                    </div>
                                    <hr />

                                    <div class="form-group">
                                        <label :class="{'text-danger': errors['jsa_steps.'+index+'.hazards.'+hIndex+'.controls']}" class="mr-1">Standard Controls:</label>
                                        <!-- is-invalid doesn't work on multiselect? It puts it on there but does nothing -->
                                        <multiselect :class="{'is-invalid': errors['jsa_steps.'+index+'.hazards.'+hIndex+'.controls']}" v-model="haz.controls" :options="controls" :multiple="true" :taggable="true" group-label="hazard_name" group-values="children" :group-select="false"></multiselect>
                                        <span v-if="errors['jsa_steps.'+index+'.hazards.'+hIndex+'.controls']" class="text-danger">
                                            <span v-for="error in errors['jsa_steps.'+index+'.hazards.'+hIndex+'.controls']">{{ error }}</span>
                                        </span>

                                    </div>
                                    <div class="form-group">
                                        <label :class="{'text-danger': errors['jsa_steps.'+index+'.hazards.'+hIndex+'.has_other_controls']}" class="mr-1">Other Controls:</label>
                                        <b-form-radio-group :class="{'is-invalid': errors['jsa_steps.'+index+'.hazards.'+hIndex+'.has_other_controls']}" plain v-model="haz.has_other_controls">
                                            <b-form-radio value="1">Yes</b-form-radio>
                                            <b-form-radio value="0">No</b-form-radio>
                                        </b-form-radio-group>
                                        <span v-if="errors['jsa_steps.'+index+'.hazards.'+hIndex+'.has_other_controls']" class="text-danger">
                                            <span v-for="error in errors['jsa_steps.'+index+'.hazards.'+hIndex+'.has_other_controls']">{{ error }}</span>
                                        </span>
                                    </div>
                                    <div class="form-group" v-if="haz.has_other_controls == 1">
                                        <label :class="{'text-danger': errors['jsa_steps.'+index+'.hazards.'+hIndex+'.other_controls']}">Other Controls</label>
                                        <b-form-textarea :class="{'is-invalid': errors['jsa_steps.'+index+'.hazards.'+hIndex+'.other_controls']}" v-model="haz.other_controls" rows="2" placeholder="Enter Other Controls"></b-form-textarea>
                                        <span v-if="errors['jsa_steps.'+index+'.hazards.'+hIndex+'.other_controls']" class="text-danger">
                                            <span v-for="error in errors['jsa_steps.'+index+'.hazards.'+hIndex+'.other_controls']">{{ error }}</span>
                                        </span>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
export default {
    data: function() {
        return {
            loading: true,
            saving: false,
            errors: {},
            jsa_id: this.$route.params.id,
            jsa: {},
            steps: [],
            hazards: [],
            controls: [],
            racLevels: [],
            JobsiteId: 0,
            options: {
                format: 'MM/DD/YYYY',
                date: ""
            },

        }
    },

    computed: {

        selectHazards(){
            //Setup
            var options = [
                {value: null, text: '-- Select a Hazard --'},
            ];

            //Loop
            for(var i in this.hazards)
            {
                options.push({value: this.hazards[i], text: this.hazards[i]});
            }

            //SEnd it
            return options;
        },

        selectRacLevels(){
            //Setup
            var options = [
                {value: null, text: '-- Select an RAC Level --'},
            ];

            //Loop
            for(var i in this.racLevels)
            {
                options.push({value: this.racLevels[i], text: this.racLevels[i]});
            }

            //SEnd it
            return options;
        },

        SiteSelectedValues(){
            //check for null
            if(!this.jsa.JobsiteId || this.jsa.JobsiteId == null)
            {
                //Check the store
                if(this.$store.state.user.jobsite)
                {
                    var jobsite = this.$store.state.user.jobsite;

                    //Set the HSE jobsite
                    this.jsa.JobsiteId = jobsite.JobsiteId;

                    //Send it
                    return {JobsiteId: jobsite.JobsiteId, JobsiteNumber: jobsite.JobsiteNumber, JobsiteName: jobsite.JobsiteName};
                }

                //Send it
                return null;
            }

            //Send it
            return {JobsiteId: this.jsa.JobsiteId, JobsiteNumber: this.jsa.JobsiteNumber, JobsiteName: this.jsa.JobsiteName};
        },

        totalHazards(){
            //Start it
            var t = 0;

            //Loop and count
            for (var i = this.steps.length - 1; i >= 0; i--)
            {
                t += this.steps[i].hazards.length;
            }

            //Send it
            return t;
        }

    },


    methods: {

        getJsaTemplate: function() {
            //Get the data
            this.$http
                .get('jsa/templates/edit' + (this.jsa_id ? '/' + this.jsa_id : ''))
                .then(response => {
                    //Set all the data
                    this.jsa = response.data.jsa;
                    this.types = response.data.types
                    this.steps = response.data.jsa.jsa_steps;

                    //Create default first step
                    if(this.steps.length == 0)
                    {
                        this.newStep();
                    }

                    //Resources Used by the Steps
                    this.hazards = response.data.hazards;
                    this.controls = response.data.controls;
                    this.racLevels = response.data.racLevels;

                    //Set loading
                    this.loading = false;
                })
                .catch(err => {
                    //Log the error
                    console.log(err);
                });
        },

        saveJsa: function() {
            //SHow loading
            this.saving = true;

            //Reset the errors
            this.errors = {};

            //Set the JSA steps before sending
            this.jsa.jsa_steps = this.steps;

            //Send it
            this.$http
                .post('jsa/templates/edit' + (this.jsa_id ? '/' + this.jsa_id : ''), this.jsa)
                .then(response => {
                    //Alert the user?
                    this.$toastr.success('JSA Template Saved');

                    //Return to main list?
                    this.$router.push('/jsa/templates/view/' + response.data.jsa_id);
                })
                .catch(error => {
                    //Check for error
                    if (error.response.status === 422) {
                        //Display validation errors
                        this.errors = error.response.data
                    }
                })
                .then(response => {
                    //SHow loading
                    this.saving = false;
                });
        },

        onJobSiteSelectUpdate (jobsite) {
                //Check for null
                if(jobsite == null)
                {
                    //Stop
                    this.jsa.JobsiteId = null;
                    return;
                }

                //Send the value
                this.jsa.JobsiteId = jobsite.JobsiteId;
                //this.incident.JobsiteName = jobsite.JobsiteName;
                //this.incident.JobsiteNumber = jobsite.JobsiteNumber;
            },

        newStep(){
            //Get the length
            var index = this.steps.length;

            //Push a new array
            this.steps.push({step_label: '', hazards: []});

            //Create the new hazard
            this.newStepHazard((index));
        },

        deleteStep(index){
            //Slice Out
            this.steps.splice(index, 1);
        },

        newStepHazard(stepIndex){
            //Loop and push
            for (var i = this.steps.length - 1; i >= 0; i--)
            {
                //Check the index
                if(i === stepIndex)
                {
                    this.steps[i].hazards.push({hazard: null, rac_level: null, has_other_controls: 0, controls: [],});
                }
            }
        },

        deleteStepHazard(stepIndex, hazardIndex){
            //Slice Out
            this.steps[stepIndex].hazards.splice(hazardIndex, 1);
        }

    },

    mounted() {
        this.getJsaTemplate();
    },

}
</script>
<style>
    .form-inline .multiselect {
        display: inline-block;
        width: auto;
    }
</style>